import { render, staticRenderFns } from "./RolePermissionDrawer.vue?vue&type=template&id=e21869b4&scoped=true"
import script from "./RolePermissionDrawer.vue?vue&type=script&lang=js"
export * from "./RolePermissionDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21869b4",
  null
  
)

export default component.exports